// Heuristic code/keyword sets used to surface clinical signals that PCC's
// FHIR data doesn't expose as discrete structured fields.

export const FALL_HISTORY_ICD_CODES = ["v15.88", "z91.81"];
export const FALL_KEYWORDS = ["fall", "faller", "fell"];

export const CODE_STATUS_KEYWORDS = [
  "dnr",
  "dni",
  "polst",
  "full code",
  "do not resuscitate",
  "do not intubate",
  "advance directive",
];

export const SURGICAL_CPT_MIN = 10000;
export const SURGICAL_CPT_MAX = 69999;

export interface WoundFieldLabel {
  key: string;
  label: string;
  regex: RegExp;
}

// First-pass patterns based on real note text from client feedback
// screenshots; validate/tune against actual Evaluations documents.
export const WOUND_FIELD_LABELS: WoundFieldLabel[] = [
  { key: "exudate", label: "Wound Exudate", regex: /Wound Exudate:?\s*([^\n\r]+)/i },
  { key: "periWound", label: "Peri Wound Condition", regex: /Peri[- ]?[Ww]ound [Cc]ondition:?\s*([^\n\r]+)/i },
  { key: "tissueType", label: "Tissue Type", regex: /Tissue Type:?\s*([^\n\r]+)/i },
  { key: "woundBed", label: "Wound Bed", regex: /Wound Bed:?\s*([^\n\r]+)/i },
  { key: "drainage", label: "Drainage", regex: /Drainage:?\s*([^\n\r]+)/i },
  { key: "odor", label: "Odor", regex: /(?:Wound )?Odor:?\s*([^\n\r]+)/i },
  { key: "location", label: "Wound Location", regex: /(?:Wound )?Location:?\s*([^\n\r]+)/i },
  { key: "length", label: "Length", regex: /Length:?\s*([^\n\r]+)/i },
  { key: "width", label: "Width", regex: /Width:?\s*([^\n\r]+)/i },
  { key: "depth", label: "Depth", regex: /Depth:?\s*([^\n\r]+)/i },
  { key: "stage", label: "Stage", regex: /Stage:?\s*([^\n\r]+)/i },
];
